import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isString } from 'lodash-es';

@Component({
  selector: 'app-alias-redirect',
  template: '',
  standalone: true
})
export class AliasRedirectComponent {
  constructor(router: Router, route: ActivatedRoute) {
    const id = route.snapshot.paramMap.get('id');
    let url = route.snapshot.data['url'] as string;
    if (isString(id) && id.length > 0) url += encodeURIComponent(id);
    router.navigateByUrl(url);
  }
}
